<template>
	<div>
		<p><b-button variant="primary" @click="$router.push({path: '/payments/create/'})"><i class="fa fa-plus"></i> Создать платёж</b-button></p>
		<vuetable ref="vuetable"
			:fields="columns"
			:api-mode="false"
			:data="tableData"
			:row-class="onRowClass"
			@vuetable:row-dblclicked="rowClickHandler"
			class="table-striped table-payment"
			noDataTemplate="Ничего не найдено">
			<template slot="amount" slot-scope="props">
				{{ props.rowData.amount | currency}}
			</template>
			<template slot="date" slot-scope="props">
				{{ dateFormat(props.rowData.date) }}
			</template>
		</vuetable>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	data () {
		return {
			tableData: [],
			columns: [
				{
					name: 'id',
					title: '#'
				}, {
					name: '__slot:amount',
					title: 'Сумма'
				}, {
					name: 'purpose',
					title: 'Назначение'
				}, {
					name: 'counterparty',
					title: 'Контрагент'
				}, {
					name: '__slot:date',
					title: 'дата'
				}, {
					name: 'manager',
					title: 'Менеджер',
					dataClass: 'nowrap'
				}, {
					name: 'product',
					title: 'Продукт'
				}, {
					name: 'b24_id',
					title: 'Б24'
				}
			]
		}
	},
	props: {
		type: String,
		dateStart: String
	},
	mounted () {
		this.getData()
	},
	methods: {
		getData () {
			this.$http.get(this.$store.state.apiURL + '/v1/payments', {
				params: {
					type: this.type,
					expand: 'company,manager,product',
					date_start: this.dateStart
				}
			}, {
			}).then(function (response) {
				this.tableData = response.body
			}, function (response) {
			})
		},
		dateFormat: function (date) {
			return moment(date).format('DD.MM.Y')
		},
		rowClickHandler (row, event) {
			if (row.is_deleted === 1) return false
			this.$router.push({path: `/payments/details/${row.id}/update`})
		},
		onRowClass (dataItem, index) {
			if (dataItem.is_deleted === 1) return 'disabled'
		}
	}
}
</script>
<style lang="scss">
.table-payment {
	.nowrap {
		white-space: nowrap;
	}
	.disabled {
		opacity: 0.4;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/payment/payment-table.vue